import { FormLabel } from '@material-ui/core'

export default FormLabel
